module.exports = __webpack_public_path__ + "static/media/fresh-honey.2b136fa6.png";